import PropTypes from 'prop-types'
import { addressPropType } from '../address/address-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'

/**
 * @typedef {Object} OrderMessageLocation
 * @property {string} [locationDescription] - location description from the tt geocoder
 * @property {orderAddressPropType} [address] - address of the message location
 */

export const orderMessageLocationPropType = PropTypes.shape({
    address: addressPropType,
    locationDescription: locationDescriptionPropType
})
